import { rerender } from './render'
rerender()
